<template>
  <h1 class="title">About</h1>
  <p>
    Working with Victoria to do homework and help her with her numbers, decided
    to write a quick game to help her, here it is, hopefully it will help
    someone else too.
  </p>
</template>
